import React from 'react';
import { SparkIcon, Text } from '@spark';
import '@/features/datasets/components/DataCollection/dataOverview/sections/AnalysisPropertyRow.css';

/**
 * Figma Data Overview property row: icon + label (+ optional description)
 * with a right-aligned value or control.
 */
const AnalysisPropertyRow = ({
    icon,
    label,
    description,
    value,
    trailing,
    children,
    className = '',
}) => (
    <div className={['data-overview-analysis-row', className].filter(Boolean).join(' ')}>
        <div className="data-overview-analysis-row__main">
            <div className="data-overview-analysis-row__lead">
                {icon ? (
                    <span className="data-overview-analysis-row__icon" aria-hidden="true">
                        <SparkIcon slug={icon} size="small" />
                    </span>
                ) : null}
                <div className="data-overview-analysis-row__copy">
                    {typeof label === 'string' ? (
                        <Text as="div" variant="base-regular" color="primary">
                            {label}
                        </Text>
                    ) : (
                        <div className="spark-text-base-regular spark-content-primary">
                            {label}
                        </div>
                    )}
                    {description ? (
                        typeof description === 'string' ? (
                            <Text as="div" variant="detail-regular" color="tertiary">
                                {description}
                            </Text>
                        ) : (
                            <div className="data-overview-analysis-row__description">
                                {description}
                            </div>
                        )
                    ) : null}
                </div>
            </div>
            {value != null && value !== '' ? (
                typeof value === 'string' || typeof value === 'number' ? (
                    <Text
                        as="div"
                        variant="base-semibold"
                        color="primary"
                        className="data-overview-analysis-row__value"
                    >
                        {value}
                    </Text>
                ) : (
                    <div className="spark-text-base-semibold spark-content-primary data-overview-analysis-row__value">
                        {value}
                    </div>
                )
            ) : null}
            {trailing ? (
                <div className="data-overview-analysis-row__trailing">{trailing}</div>
            ) : null}
        </div>
        {children ? (
            <div className="data-overview-analysis-row__extra">{children}</div>
        ) : null}
    </div>
);

export default AnalysisPropertyRow;
